import { render } from "./IndicatorDataTableEditor.vue?vue&type=template&id=1a441404&scoped=true"
import script from "./IndicatorDataTableEditor.vue?vue&type=script&lang=js"
export * from "./IndicatorDataTableEditor.vue?vue&type=script&lang=js"

import "./IndicatorDataTableEditor.vue?vue&type=style&index=0&id=1a441404&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a441404"]])

export default __exports__